module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uy8ITfFKzdr8ZMHWQnav98F",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Basic_Bold"
  }, [_c('a', {
    attrs: {
      "id": "uTpbrA5J7bWWa7Jt4wPvNRB"
    }
  }), _vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH _idGenParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Basic_italics"
  }, [_c('a', {
    attrs: {
      "id": "u9YvNxc7i2HZa5ZeL6MJom4"
    }
  }), _vm._v("I sit behind bars an innocent man. I sit behind bars condemned by public opinion. I sit behind bars condemned of murder of innocent children. I sit behind bars condemned by a psychologist who has never met me, of being an “unfeeling animal!” I sit behind bars listening to all they say about me on the outside and ask my Lord “why”!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5fa9e32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Prologue.vue
// module id = 78
// module chunks = 0